import { render, staticRenderFns } from "./veStuMoralActiveEdit.vue?vue&type=template&id=11779a91&scoped=true"
import script from "./veStuMoralActiveEdit.vue?vue&type=script&lang=js"
export * from "./veStuMoralActiveEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11779a91",
  null
  
)

export default component.exports